import DebugLocationPopup from "@components/Debug/LocationPopup";
import TypeIcon from "@components/Location/TypeIcon";
import HtmlLabel from "@hudson/ui/components/FormFields/HtmlLabel";
import useContent from "@lib/use_content";

function Location({
  location,
  shiftLeft,
  flip,
  hideString,
  horizontal,
  small,
}: {
  hideString?: boolean;
  location: be.Location;
  shiftLeft?: boolean;
  flip?: boolean;
  horizontal?: boolean;
  small?: boolean;
}): JSX.Element {
  const { data } = useContent(["beLocationStringLabel"]);

  let flex;
  if (horizontal) {
    flex = flip
      ? "flex-col justify-start xs:flex-row-reverse"
      : "flex-col justify-start xs:flex-row";
  } else {
    flex = flip ? "flex-row-reverse" : "flex-row";
  }

  return (
    <>
      <div className={`relative flex space-x-3 pr-3 ${flex} `}>
        <div
          className={`pt-0 pb-1 pr-2 ${shiftLeft ? "pl-4" : "pl-2"} ${flip ? "ml-3" : "mr-1"} ${
            horizontal ? "hidden xs:flex" : "flex"
          } items-center justify-center rounded-lg bg-gradient-to-tl from-[--primary-color] via-[--primary-color] via-5% to-[--primary-color-darker]`}
        >
          {location.typeString && (
            <TypeIcon
              className={`${
                small ? `h-5 ${shiftLeft ? "w-7" : "w-10"} mt-0.5` : "h-10 w-10 mt-1.5"
              } `}
              color="white"
              type={location.typeString}
              typeKey={location.type}
            />
          )}
        </div>
        <div className="flex justify-between flex-1 min-w-0">
          <div className="self-center">
            <p className={`${small ? "text-sm" : "text-base"} font-bold text-gray-700`}>
              {location.displayName}
              <DebugLocationPopup label="?" location={location} className="inline-block ml-2" />
            </p>
            {location.displayAddress && (
              <p className={`${small ? "text-xs" : "text-sm"} text-gray-500`}>
                {location.displayAddress}
              </p>
            )}
            {!hideString && location.string && data?.content.beLocationStringLabel && (
              <div className="relative inline-flex items-center px-3 py-2 mt-3 mr-4 text-sm font-bold text-yellow-900 rounded-md focus:z-10 ring-1 ring-inset ring-yellow-800 bg-yellow-50 ">
                <HtmlLabel text={location.string} />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Location;
